export enum ServiceAgreementState {
  PENDING = 'PENDING',
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED',
  TERMINATED = 'TERMINATED',
}
